import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { UserFullInformation } from '../../../../models/UserFullInformation';
import { GetUserRestriction } from '../../../../reduxToolkit/restrictions/RestrictionApi';
import { userInfoStatus } from '../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import { GetUserFullInformation, UpdateUserProfile } from '../../../../reduxToolkit/Commons/CommonsApi';
import { UnlinkUserDevice } from '../../../../reduxToolkit/Providers/providersApi';
import { UpdateUserExtraData } from '../../../../reduxToolkit/Contractor/ContractorApi';
import { useNavigate } from 'react-router-dom';
import { permissionObj } from '../../../../Helpers/permission';
import { USER_TYPE_NAME_MODEL } from '../../../../enums/userTypeEnum';
import { getPhotoPicker, PHOTO_PICKER_MODEL } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import defaultImage from '../../../../assets/ImagesDefaults/ic-person-v2.svg';
import {isEmailFormat, isPhoneFormat, isValidLengthDocumentId, validateMinLengthTrimmed} from '../../../../Apis/functions';
import { ProfileOne, ProfileThree, ProfileTwo, ProfileOneMobile, ProfileThreeMobile, ProfileTwoMobile } from '../../../../components/buttons/IconButtons';
import { PROFILE_VIEW } from '../model';
import IconPersonDefaultV2 from '../../../../assets/ImagesDefaults/ic-person-v2.svg';
import { PASSWORD_MIN_LENGTH } from '../../../../constant/variable';

const ProfileProviderApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { headersList } = useSelector((state) => state.headersSlice);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const { getUserFullInformation } = useSelector((state) => state.CommonsSlice);
    const userType = user?.data?.userType?.name;
    const storageId = sessionStorage.getItem('id');
    const statusId = user?.data?.status?.id;
    //use state
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [modalShow, setModalShow] = React.useState(false);
    const [disable, setDisable] = React.useState(!DEV && !permission?.includes(permissionObj.WEB_PROFILE_UPDATE)
        && contractorId === null && supplierId === null,
    );
    const [userFull, setUserFull] = useState(UserFullInformation);
    const [showModal, setShowModal] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidPassword, setIsValidPassword ] = useState(true);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const [isValidDocumentId, setIsValidDocumentId] = useState(true);
    const [isValidDob, setIsValidDob] = useState(true);
    const [emptyFields, setEmptyFields] = useState(false);
    const [extra, setExtra] = useState(false);

    const [secretModal, setSecretModal] = useState(false);
    const [secretKey, setSecretKey] = useState(null);

    //uploading file state
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL, preview: defaultImage });

    // Resolves the selected image from the photo picker (uploaded or selfie).
    const imagePicker = photoPicker?.srcSelected || photoPicker?.selfieSrc;

    // Returns the translated label for the user type, or a default message if not available.
    const getUserTypeLabel = (value, t) => {
        const key = userType[value];
        return key ? t(key) : t('not_information');
    };

    // Controls the current profile subview.
    const [subView, setSubView] = useState(PROFILE_VIEW.USER_DATA);
    
    // Handles changes between subviews (tabs, sections, etc.)
    const handleSubViewChange = (value) => {
        setSubView(value);
    };

    // Initializes based on the current window width
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Effect to listen for window resize events and update `isMobile` dynamically
    useEffect(() => {
        // Function to check screen width and update state
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Arrays of profile components for desktop and mobile views
    const profilesDesktop = [ProfileOne, ProfileTwo, ProfileThree];
    const profilesMobile = [ProfileOneMobile, ProfileTwoMobile, ProfileThreeMobile];

    // Memoized calculation of a random index based on current device type
    // Recomputes only when `isMobile` changes
    const randomIndex = useMemo(() => {
    const profiles = isMobile ? profilesMobile : profilesDesktop;
    return Math.floor(Math.random() * profiles.length);
    }, [isMobile]);

    // Uses the previously generated random index and current device type
    const RandomProfile = useMemo(() => {
    return isMobile
        ? profilesMobile[randomIndex]
        : profilesDesktop[randomIndex];
    }, [isMobile, randomIndex]);


    // Determines the profile image preview (picker image, stored selfie, or default icon).
    const previewImage =
        imagePicker ??
        (userFull?.selfie != null && userFull.selfie !== ''
            ? `data:image/png;base64,${userFull.selfie}`
            : IconPersonDefaultV2);

    // useEffect for api and state manage
    useEffect(() => {
        dispatch(GetUserRestriction()).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                const extraDataProperty =
                    userType === USER_TYPE_NAME_MODEL.EMPLOYEE
                        ? data?.extraDataEmployee
                        : userType === USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE
                          ? data?.extraDataContractor
                          : userType === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE
                            ? data?.extraDataSupplier
                            : null;

                setExtra(extraDataProperty);
            },
        );

        dispatch(userInfoStatus());
    }, []);

    useEffect(() => {
        if(getUserFullInformation){
            setUserFull((prevData) => ({
                ...prevData,
                ...getUserFullInformation,
                password: prevData.password,
            }));
        }
    }, [getUserFullInformation]);

    /**
     * handle for unlink device
     * @param props
     */
    const handleUnlinkDevice = () => {
        dispatch(UnlinkUserDevice(storageId)).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                if (success === true) {
                    dispatch(GetUserFullInformation(storageId)).then(
                        ({
                            payload: {
                                data: { data },
                            },
                        }) => {
                            setUserFull((prevData) => ({
                                ...prevData,
                                ...data,
                                password: prevData.password,
                            }));
                            setModalShow(false);
                        }
                    );
                }
            }
        );
    };

    /**
     * This function handles changes in the form fields. It updates the 'userData' state by spreading
     * the previous data and updating the specific field (identified by 'name') with the new value from the form input.
     * @param e
     */

    const handleFormChangeUserData = (e) => {
        const { name, value } = e.target;
        setUserFull((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    /**
     * handlde to save changes  profile, extradata
     */
    const handleSubmit = () => {
        setEmptyFields(true);
        if (
            userFull.isValidFromProfile() &&
            isValidEmail &&
            isValidDob &&
            isValidPhoneNumber &&
            isValidDocumentId &&
            isValidPassword
        ) {
            const imageFile = getPhotoPicker(photoPicker);
            dispatch(
                UpdateUserProfile({
                    data: userFull.toUpdateNormal(),
                    file: imageFile,
                    updateImage: userFull.selfie !== null,
                }),
            ).then(
                ({
                    payload: {
                        data: { data },
                    },
                }) => {
                    setUserFull((prevData) => ({
                        ...prevData,
                        ...data,
                    }));
                    if (userFull.password && userFull.password.trim() !== '') {
                        setSecretModal(true);
                        setSecretKey(data.secret);
                    }
                },
            );

            if (extra) {
                dispatch(UpdateUserExtraData({ id: sessionStorage.getItem('id'), body: userFull.toUpdateExtra() }));
            }
        }
    };


    /**
     * handle to validate document id
     */
    const validateDocumentId = () => {
        const value = userFull.documentId;

        if (value !== undefined && value !== null && typeof value === 'string' && value.trim() !== '') {
            setIsValidDocumentId(isValidLengthDocumentId(value.trim()));
        } else {
            setIsValidDocumentId(true);
        }
    };

    const validateEmail = () => {
        if(userFull.email !== '' && userFull.email != null && typeof userFull.email != 'undefined'){
            setIsValidEmail(isEmailFormat(userFull.email));
        }else{
            setIsValidEmail(false);
        }
    };

    /**
     * handle to validate phone
     */
    const validatePhone = () => {
        if(userFull.phoneNumber !== '' && userFull.phoneNumber != null && typeof userFull.phoneNumber != 'undefined'){
            setIsValidPhoneNumber(isPhoneFormat(userFull.phoneNumber));
        }else{
            setIsValidPhoneNumber(true);
        }
    };

    useEffect(() => {
        validatePhone();
    }, [userFull.phoneNumber]);

    useEffect(() => {
        validateDocumentId();
    }, [userFull.documentId]);

    useEffect(() => {
        if (userFull.email) {
            validateEmail();
        }
    }, [userFull.email]);

    useEffect(() => {
     const isValid = validateMinLengthTrimmed(userFull.password, {
            minLength: PASSWORD_MIN_LENGTH,
            allowEmpty: true,
        });

        setIsValidPassword(isValid);
    }, [userFull.password]);


    return {
        t,
        navigate,
        disable,
        permission,
        DEV,
        statusId,
        headersList,
        userFull,
        setUserFull,
        modalShow,
        setModalShow,
        showModal,
        setShowModal,
        isValidEmail,
        setIsValidEmail,
        isValidPhoneNumber,
        setIsValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        emptyFields,
        setEmptyFields,
        extra,
        setExtra,
        contractorId,
        setContractorId,
        supplierId,
        setSupplierId,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        isValidDocumentId,
        setIsValidDocumentId,
        handleUnlinkDevice: (e) => handleUnlinkDevice(e),
        handleFormChangeUserData: (e) => handleFormChangeUserData(e),
        handleSubmit: (e) => handleSubmit(e),
        photoPicker,
        setPhotoPicker,
        RandomProfile,
        previewImage,
        getUserTypeLabel,
        subView,
        handleSubViewChange,
        isMobile
    };
};

export default ProfileProviderApp;
